import { render, staticRenderFns } from "./incorrectCourierValidation.vue?vue&type=template&id=ab8b1066&scoped=true&"
import script from "./incorrectCourierValidation.vue?vue&type=script&lang=js&"
export * from "./incorrectCourierValidation.vue?vue&type=script&lang=js&"
import style0 from "./incorrectCourierValidation.vue?vue&type=style&index=0&id=ab8b1066&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8b1066",
  null
  
)

export default component.exports